import { useContext } from "react";
import { ResumeContext } from "../../../../context/resume/resume-context";
import useResumeDocumentSection from "../../../../hooks/useResumeDocumentSection";
import CategoryItem from "./CategoryItem";

export default function CategoryList() {

    const { refCompetences, refCompetencesCategories } = useContext( ResumeContext );
    const { businessSkills } = useResumeDocumentSection();

    return (
        <div className="d-flex flex-wrap gap-3 mb-2" style={ { maxWidth: '100%' } }>
            { businessSkills
                ?.sort( ( a, b ) => a.order - b.order )
                .map( category => (
                    <CategoryItem
                        key={ category.order }
                        item={ category }
                        numberOfItems={ businessSkills.length }
                        refCompetences={ refCompetences }
                        refCompetencesCategories={ refCompetencesCategories }
                    />
                ) ) }
        </div>
    );
}
